import React, { Fragment, useState, useEffect } from 'react';
import Spinner from '../../../components/Spinner';
import BarChartComponent from '../../../components/Charts/SingleBarChart';
import AssetBreakdown from '../components/AssetBreakdown';
import ChainSplit from '../components/ChainSplit';
import {
  defiWalletDetailSelector,
  getWalletDefiChain,
} from '../../../store/defi/walletDetailSlice';
import { useDispatch, useSelector } from 'react-redux';

const Chain = ({ account }) => {
  const dispatch = useDispatch();
  const [tokenChainBreakdown, setTokenChainBreakdown] = useState();
  const [chainTotalAmounts, setChainTotalAmounts] = useState();

  const { loading, token_chain_breakdown, chain_total_amounts, available_chains } =
    useSelector(defiWalletDetailSelector);

  useEffect(() => {
    dispatch(getWalletDefiChain({ account }));
  }, [account, dispatch]);

  useEffect(() => {
    setChainTotalAmounts(chain_total_amounts);
    setTokenChainBreakdown(token_chain_breakdown);
  }, [chain_total_amounts, token_chain_breakdown]);

  // useEffect(() => {
  //   setLoading(true);
  //   let timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 2000); // TODO: remove this setTimeout. Just to mimic loading.

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <Fragment>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div style={{ display: 'flex', paddingBottom: '12rem' }}>
            <div style={{ flexBasis: '33.33%', marginRight: '10px', overflowX: 'hidden' }}>
              <ChainSplit chain_total_amounts={chainTotalAmounts} />
            </div>

            <div style={{ flexBasis: '33.33%', marginRight: '10px', overflowX: 'hidden' }}>
              <div className="home_card">
                <div>
                  <div style={{ marginBottom: '58px' }}>
                    <span className="heading_text">Chain Split Value</span>
                  </div>
                  <div
                    style={{
                      marginTop: '1rem',
                      marginBottom: '1rem',
                    }}
                  >
                    <BarChartComponent data={chainTotalAmounts} direction="vertical" />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ flexBasis: '33.33%' }}>
              <AssetBreakdown
                available_chains={available_chains}
                chain_asset_breakdown={tokenChainBreakdown}
                direction="vertical"
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Chain;
